export default __webpack_public_path__ + "static/media/screen_1_top.8f8ed341.png";